export default [
	{
		title: 'Location',
		subTitle: 'Create or edit Locations',
		content: [
			'Justin and Jared I still need this'
		]
	},
]



/** WEBPACK FOOTER **
 ** ./src/helpers/locations/LocationInfo.js
 **/